export default __webpack_public_path__ + "static/media/pulse.829ebc1d.svg";